import { render, staticRenderFns } from "./BannedOrRestrictedUsersUploader.vue?vue&type=template&id=c78cfdc6"
import script from "./BannedOrRestrictedUsersUploader.vue?vue&type=script&lang=ts"
export * from "./BannedOrRestrictedUsersUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports